import { APP_BOOTSTRAP_LISTENER } from '@angular/core';
import { UserMenuService } from '@abp/ng.theme.shared';
import { eUserMenuItems } from '@volosoft/abp.ng.theme.lepton-x';

export const APP_USER_MENU_PROVIDER = [
  {
    provide: APP_BOOTSTRAP_LISTENER,
    multi: true,
    deps: [UserMenuService],
    useFactory: patchAuthorityDelegationIconFactory,
  },
];

function patchAuthorityDelegationIconFactory(userMenuService: UserMenuService) {
  return () => {
    let patched = false;

    const subscription = userMenuService.items$.subscribe(items => {
      if (patched) {
        return;
      }

      const authorityDelegationItem = items.find(
        item => item.id === eUserMenuItems.AuthorityDelegation,
      );

      if (!authorityDelegationItem?.textTemplate) {
        return;
      }

      patched = true;
      userMenuService.patchItem(eUserMenuItems.AuthorityDelegation, {
        textTemplate: {
          ...authorityDelegationItem.textTemplate,
          icon: 'bi bi-people-fill',
        },
      });
      subscription.unsubscribe();
    });
  };
}
